<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
		 	<h1 class="h11">新建工单</h1>
			<el-form class="form-news" ref="news" label-width="100px" :model="news">
			  <el-form-item label="标题："
			  prop="title"
			  :rules="{
				required: true, message: '标题不能为空', trigger: 'blur'
				}"
			  >
			    <el-input class="width3" v-model="news.title"></el-input>
			  </el-form-item>
			  
			  <el-form-item label="动态类型："
			  prop="wt_id"
			  :rules="{
				required: true, message: '动态类型不能为空', trigger: 'change'
				}"
			  >
			    <el-select v-model="news.wt_id" placeholder="请选择类型">
			      <el-option v-for="(item,index) in typeList" :key="index" :label="item.caption" :value="item.id"></el-option>
			    </el-select>
			  </el-form-item>
			  <el-form-item label="优先级："
			  prop="urgent"
			  :rules="{
				required: true, message: '优先级不能为空', trigger: 'change'
				}"
			  >
					<el-radio-group v-model="news.urgent">
						<el-radio label="2">重要</el-radio>
						<el-radio label="1">一般</el-radio>
					</el-radio-group>
				</el-form-item>
			  <el-form-item label="详情："
			  prop="detail"
			  :rules="{
				required: true, message: '详情不能为空', trigger: 'blur'
				}"
			  >
			    <el-input type="textarea" v-model="news.detail"></el-input>
			  </el-form-item>
			  <el-form-item label="附件：">
				
			    <el-upload
			        :action='picUrl'
			        ref='upload'
			        :limit="imgLimit"
			        :file-list="productImgs"
			        :on-preview="handlePictureCardPreview"
			        :on-remove="handleRemove"
			        :on-success="handleAvatarSuccess"
			        :before-upload="beforeAvatarUpload"
			        :on-exceed="handleExceed"
			        :on-error="imgUploadError">
			        <el-button size="small" type="primary">点击上传</el-button>
			      </el-upload>
			  </el-form-item>
			  
			  
			  <el-form-item class="text-center">
			    <el-button type="primary" @click="onSubmit(news)">确认提交</el-button>
			  </el-form-item>
			  
			</el-form>
			<el-dialog :visible.sync="dialogVisible" size="tiny">
			  <img width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
		</div>
		
	</div>
</template>

<script>
	export default {
	    data() {
	      return {
	        news: {	  
	        },
	        dialogImageUrl: '',
	        dialogVisible: false,
			productImgs: [],
			
	        imgLimit: 5,
			picUrl: this.$store.state.domain2+"/admin/Wordermanage/uploadfile",
			typeList:[],
			removeFlag:false,

	      };
	    },
	    mounted(){
		    this.$nextTick(function(){
				this.getTypes();
		  	})
		  },
	    methods:{
	    	
			getTypes(){
				let setNewPassParams={
					uid:this.getCookie('uid'),			
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
				};
				this.sign2(setNewPassParams);
				this.$ajax.post(this.$store.state.domain2+'/admin/Wordermanage/wordertype',this.$qs.stringify(setNewPassParams),{
					emulateJSON: true
				}).then(res=>{
					if(res.data.code=="200"){
		        		this.typeList = res.data.data;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
				});
				
			},
			onSubmit(news){
				
				this.$refs.news.validate((valid) => {
					if (valid) {
						let setNewPassParams={
							uid:this.getCookie('uid'),
							username:this.getCookie('username'),
							title:this.news.title,								
							detail:this.news.detail,								
							wt_id:this.news.wt_id,								
							urgent:this.news.urgent,								
							path:this.news.path || "",
							token:this.getCookie('token'),
							time:Date.parse( new Date()),
							terminalId:4
						};
						this.sign2(setNewPassParams);
						this.$ajax.post(this.$store.state.domain2+'/admin/Wordermanage/add',this.$qs.stringify(setNewPassParams),{
							emulateJSON: true
						}).then(res=>{
							if(res.data.code=="200"){
								this.news = {}
								this.$message.success(res.data.msg);
							}else if(res.data.code==10008){
								this.delCookie('username');
								this.$router.push('/login/');
								this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
							}else{
								this.$message.error(res.data.msg);
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				
				
			},
			
	    	// 多个文件
			handleRemove(file, fileList) {//移除图片
				var imageList = this.news.path.split(',')
				let index = this.productImgs.indexOf(file);
				if(index!=-1){
					this.productImgs.splice(index,1);
					imageList.splice(index,1);
				}
				this.news.path = imageList.join(',');
//		        console.log(file, fileList);
				console.log(this.productImgs)
		      },
		      handlePictureCardPreview(file) {//预览图片时调用
//		        console.log(file);
		        this.dialogImageUrl = file.url;
		        this.dialogVisible = true;
		      },
		 
			  beforeAvatarUpload(file) {//文件上传之前调用做一些拦截限制
			  
		        const isLt2M = file.size / 1024 / 1024 < 2;
		 		        
		        if (!isLt2M) {
		          this.$message.error('上传图片大小不能超过 2MB!');
		        }
		        return isLt2M;
		      },
//		      多个文件
			  handleAvatarSuccess(res, file) {//上传成功
			  console.log(res,file,'upload--------');
			  
		        //地址赋值
		        
				if(res.data.path && res.data.path!=""){
					if(this.news.path=="" || !this.news.path){
						this.news.path = res.data.path;
					}else{
						this.news.path = this.news.path + ',' + res.data.path;
					}
					
				}
				if(this.news.path && this.news.path!=""){
					this.productImgs = [];
					var imageList = this.news.path.split(',')
					for(var i=0;i<imageList.length;i++){
						
						this.productImgs.push(
							{
								name:imageList[i].replace(/(.*\/)*([^.]+).*/ig,"$2") + "." + imageList[i].replace(/.+\./,""),
								url:this.$store.state.domain+imageList[i]
							}
						);
					}
						
				}
		        
		        
		      },
		      handleExceed(files, fileList) {//图片上传超过数量限制
		        this.$message.error('只能上传一张图片!');
//		        console.log(file, fileList);
		      },
		      imgUploadError(err, file, fileList){//图片上传失败调用
		        console.log(err)
		        this.$message.error('上传图片失败!');
		      }

	    }
	  }
</script>

<style>
	.el-textarea__inner{
		height: 150px;
	}
</style>


// WEBPACK FOOTER //
// src/components/rightPanel/newOrder.vue